export const EDIT_STATUS_VALUES = [
  'DRAFT',
  'PENDING',
  'IN_PROGRESS',
  'COMPLETED',
  'PUBLISHED',
] as const;

export type EditStatusType = typeof EDIT_STATUS_VALUES[number];